export default {
  'redeemCoupon.title': 'แลกคูปอง',
  'redeemCoupon.message.one': 'ระบบจะหัก',
  'redeemCoupon.message.two': 'แต้มเพื่อแลกรับ',
  'redeemCoupon.unit': 'ใบ',
  'redeemCoupon.exchange_success': 'แลกคูปองสำเร็จ',
  'redeemCoupon.exchange_fail': 'แลกคูปองไม่สำเร็จ',
  'redeemCoupon.no_service.one': 'ขณะนี้ยังไม่มีบริการแลกบัตรคูปอง',
  'redeemCoupon.no_service.two': 'หากต้องการใช้บริการ กรุณาติดต่อฝ่ายบริการลูกค้าแบรนด์',
  'redeemCoupon.button': 'แลก',
  'redeemCoupon.ok_text.one': 'ยืนยัน',
  'redeemCoupon.ok_text.two': 'ตกลง',
  'redeemCoupon.getting_time': 'ช่วงเวลาการรับคูปอง',
  'redeemCoupon.time.start': 'เริ่ม',
  'redeemCoupon.time.end': 'สิ้นสุด',
} as Record<string, string>;
